<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        จัดการข้อมูลรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <div class="pull-right box_add" v-if="isProvider && manage_permission.includes('add')">
                      <button
                        @click="add_promotion_dialog('CMS')"
                        style="margin-right:2px;"
                        class="btn btn-info btn_custom"
                      >
                        <i class="fa fa-plus"></i> เพิ่มรายการส่งเสริมการขาย
                      </button>
                      <el-dialog title="'เพิ่มรายการส่งเสริมการขาย'" :visible.sync="addPromotionDialog" center>
                        <el-form :label-position="'left'">
                          <el-form-item label="รอบการนำส่งข้อมูลประจำเดือน (เดือน/ปี)" required>
                            <el-select v-model="monthly_regulate">
                              <el-option v-for="item in regulate_list" :key="item.data"  :value="item.data" :label="item.label"></el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                          <el-button @click="addPromotionDialog = false">ปิดหน้าต่าง</el-button>
                          <el-button type="primary" @click="addPromotion()">ยืนยัน</el-button>
                        </span>
                      </el-dialog>
                      <button
                        @click="add_promotion_dialog('PDF')"
                        style="margin-left:2px;"
                        class="btn btn-warning"
                      >
                        <i class="fa fa-plus"></i>
                        อัปโหลดไฟล์ PDF
                      </button>
                    </div>
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item
                            label="ชื่อรายการส่งเสริมการขาย"
                            prop="namePromotion"
                          >
                            <el-input
                              clearable
                              v-model="form.namePromotion"
                            ></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ชนิดของรายการส่งเสริมการขาย"
                            prop="typeOfservice"
                          >
                            <el-select filterable v-model="form.promotion_type">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option label="รายการส่งเสริมการขายหลัก (Main)" value="main"></el-option>
                              <el-option label="รายการส่งเสริมการขายเสริม (On-top)" value="on-top" ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="ผู้ให้บริการ">
                            <el-select v-model="form.provider_id" :disabled="usertype == 'operator'">
                              <el-option label="ทั้งหมด" value=""></el-option>
                              <el-option v-for="item in provider" :key="item.id" :label="item.provider_name" :value="item.id" ></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            label="ประเภทบริการของรายการส่งเสริมการขาย"
                            prop="service_type"
                          >
                            <el-select
                              filterable
                              v-model="form.promotion_category"
                            >
                              <el-option
                                label="ทั้งหมด"
                                value=""
                              ></el-option>
                              <el-option
                                label="ระบบรายเดือน (Postpaid)"
                                value="postpaid"
                              ></el-option>
                              <el-option
                                label="ระบบเติมเงิน (Prepaid)"
                                value="prepaid"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะการให้บริการ">
                            <el-checkbox-group v-model="form.service_status">
                              <div class="col-md-6">
                                <el-checkbox label="S">(S) เฉพาะรายการส่งเสริมการขายใหม่ (ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="U">(U) ไม่ขายแล้วแต่ยังให้บริการอยู่</el-checkbox><br/>
                                <el-checkbox label="X">(X) ยกเลิกการให้บริการแล้ว</el-checkbox>
                              </div>
                              <div class="col-md-6">
                                <el-checkbox label="CS">(CS) Corporate (ยังขายอยู่)</el-checkbox><br/>
                                <el-checkbox label="CU">(CU) Corporate (ไม่ขายแล้วแต่ยังให้บริการอยู่)</el-checkbox><br/>
                                <el-checkbox label="CX">(CX) Corporate (ยกเลิกการให้บริการแล้ว)</el-checkbox>
                              </div>
                            </el-checkbox-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item label="สถานะของรายการส่งเสริมการขาย">
                            <el-radio-group v-model="form.promotion_status">
                              <el-radio label="active">ให้บริการตามปกติ</el-radio>
                              <el-radio label="processing">ระหว่างดำเนินการแก้ไข</el-radio>
                              <el-radio label="suspend">ระงับการใช้งานชั่วคราว</el-radio>
                              <el-radio label="delete">รายการที่ถูกลบ</el-radio>
                              <el-radio label="">ทั้งหมด</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                        <div class="col-sm-12">
                          <el-form-item
                            label="ช่วงราคา (บาท)"
                            class="slider_price"
                          >
                            <el-slider
                              v-model="form.priceRange"
                              :step="100"
                              range
                              :max="1600"
                              :show-input="true"
                              :show-stops="true"
                              :format-tooltip="changeTooltip"
                              clearable
                              :marks="{
                                0: '0',
                                100: '100',
                                200: '200',
                                300: '300',
                                400: '400',
                                500: '500',
                                600: '600',
                                700: '700',
                                800: '800',
                                900: '900',
                                1000: '1000',
                                1100: '1100',
                                1200: '1200',
                                1300: '1300',
                                1400: '1400',
                                1500: '1500',
                                1600: '1500 ขึ้นไป'
                              }"
                            ></el-slider>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="loadData(null, form)"
                        >
                          ค้นหา
                        </button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <!-- table -->
              <div class="table-responsive">
                <div class="box-body">
                  <data-tables-server
                    @query-change="loadData"
                    :data="data_table"
                    :total="total"
                    :page-size="form.page_size"
                    :current-page.sync="current_page"
                    :pagination-props="{
                      background: true,
                      pageSizes: [10, 20, 50]
                    }"
                    :table-props="tableProps"
                    >
                    <el-table-column sortable="custom" prop="cr_status" label="สถานะของรายการส่งเสริมการขาย" width="250">
                      <template slot-scope="scope" > {{ scope.row.deleted_at != "" && scope.row.deleted_at != null ? 'ถูกลบแล้ว' : scope.row.cr_status === null || scope.row.cr_status === 'approve_edit' || ( scope.row.cr_status === 'reject_request' && scope.row.active_status === 1 ) ? 'ให้บริการตามปกติ' : cr_status_th[scope.row.cr_status] }}</template>
                        <!-- <template slot-scope="scope" > {{ scope.row.cr_status !== null && scope.row.cr_status !== 'approve_edit' ? cr_status_th[scope.row.cr_status] : 'ให้บริการตามปกติ' }}</template> -->
                    </el-table-column>
                    <el-table-column sortable prop="promotion_code" label="รหัสรายการส่งเสริมการขาย" width="220"></el-table-column>
                    <el-table-column sortable prop="promotion_name_th" label="ชื่อรายการส่งเสริมการขาย (ภาษาไทย)" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column sortable prop="promotion_name_en" label="ชื่อรายการส่งเสริมการขาย (ภาษาอังกฤษ)" show-overflow-tooltip width="200"></el-table-column>
                    <el-table-column sortable prop="promotion_category" label="ประเภทบริการของรายการส่งเสริมการขาย" width="310"></el-table-column>
                    <el-table-column sortable prop="promotion_type" label="ชนิดของรายการส่งเสริมการขาย" width="250"></el-table-column>
                    <el-table-column label="จำนวนวันการให้บริการ ของรายการส่งเสริมการขาย" align="center">
                      <el-table-column sortable prop="number_of_service_days" label="(วัน)" align="center" width="240"></el-table-column>
                    </el-table-column>
                    <el-table-column label="ระยะเวลา" align="center">
                      <el-table-column sortable prop="start_sale_date" label="เริ่มต้นของการเสนอขาย" width="200">
                        <template slot-scope="scope">{{ scope.row.start_sale_date === "Invalid date" ? "" : scope.row.start_sale_date }}</template>
                      </el-table-column>
                      <el-table-column sortable prop="end_sale_date" label="สิ้นสุดของการเสนอขาย" width="200">
                        <template slot-scope="scope">{{ scope.row.end_sale_date === "Invalid date" || !scope.row.end_sale_date ? "" :scope.row.end_sale_date }}</template>
                      </el-table-column>
                      <el-table-column sortable prop="start_service_date" label="เริ่มต้นของการให้บริการ" width="200">
                        <template slot-scope="scope">{{ scope.row.start_service_date === "Invalid date" ? "" : scope.row.start_service_date }}</template>
                      </el-table-column>
                      <el-table-column sortable prop="end_service_date" label="สิ้นสุดของการให้บริการ" width="200">
                        <template slot-scope="scope">{{ scope.row.end_service_date === "Invalid date" || !scope.row.end_service_date ? "" : scope.row.end_service_date }}</template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column sortable prop="service_status" label="สถานะการให้บริการ" width="180"></el-table-column>
                    <el-table-column sortable prop="promotion_price" label="ค่าบริการเหมาจ่ายรวมตามสิทธิการใช้งาน" width="310"></el-table-column>
                    <el-table-column label="ค่าบริการจำแนกตามประเภทบริการ (บาท)" align="center">
                      <el-table-column sortable prop="voice_service" label="บริการเสียง" width="130"></el-table-column>
                      <el-table-column sortable prop="sms_service" label="บริการ SMS" width="130"></el-table-column>
                      <el-table-column sortable prop="mms_service" label="บริการ MMS" width="130"></el-table-column>
                      <el-table-column sortable prop="internet_service" label="บริการ Internet" width="150"></el-table-column>
                      <el-table-column sortable prop="wifi_service" label="WiFi" width="100"></el-table-column>
                      <el-table-column sortable prop="other_service" label="Others" width="100"></el-table-column>
                    </el-table-column>
                    <el-table-column label="สิทธิการใช้งานที่ผู้ใช้บริการได้รับจำแนกตามประเภทบริการ" align="center">
                      <el-table-column label="บริการเสียง" align="center">
                        <el-table-column sortable prop="voice_minute" label="(นาที)" width="100px"></el-table-column>
                        <el-table-column sortable prop="voice_second" label="(วินาที)" width="100px"></el-table-column>
                        <el-table-column sortable prop="voice_unlimited" label="Unlimited" width="120px">
                            <template slot-scope="scope" v-if="scope.row.voice_unlimited == 1">✔</template>
                        </el-table-column>
                        <el-table-column sortable prop="voice_remark_th" label="เงื่อนไข (ภาษาไทย)" width="180px"></el-table-column>
                        <el-table-column sortable prop="voice_remark_en" label="เงื่อนไข (ภาษาอังกฤษ)" width="200px"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ SMS" align="center">
                        <el-table-column sortable prop="sms_amount" label="(ข้อความ)" width="120"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ MMS" align="center">
                        <el-table-column sortable prop="mms_amount" label="(ข้อความ)" width="120"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการอินเทอร์เน็ต" align="center" color="black">
                        <el-table-column sortable prop="internet_MB" label="(MB)" width="80"></el-table-column>
                        <el-table-column sortable prop="internet_GB" label="(GB)" width="80"></el-table-column>
                        <el-table-column sortable prop="internet_unlimited" label="Unlimited" width="120px">
                            <template slot-scope="scope" v-if="scope.row.internet_unlimited == 1">✔</template>
                        </el-table-column>
                        <el-table-column sortable prop="internet_remark_th" label="เงื่อนไข (ภาษาไทย)" width="180"></el-table-column>
                        <el-table-column sortable prop="internet_remark_en" label="เงื่อนไข (ภาษาอังกฤษ)" width="200"></el-table-column>
                      </el-table-column>
                      <el-table-column label="ความเร็วอินเทอร์เน็ต" align="center">
                        <el-table-column sortable prop="internet_speed_Kbps" label="(Kbps)" width="100"></el-table-column>
                        <el-table-column sortable prop="internet_speed_Mbps" label="(Mbps)" width="100"></el-table-column>
                        <el-table-column sortable prop="internet_speed_remark_th" label="เงื่อนไข (ภาษาไทย)" width="180"></el-table-column>
                        <el-table-column sortable prop="internet_speed_remark_en" label="เงื่อนไข (ภาษาอังกฤษ)" width="200"></el-table-column>
                      </el-table-column>
                      <el-table-column label="WiFi" align="center">
                        <el-table-column sortable prop="wifi_service_th" label="คำอธิบาย (ภาษาไทย)" width="210"></el-table-column>
                        <el-table-column sortable prop="wifi_service_en" label="คำอธิบาย (ภาษาอังกฤษ)" width="220"></el-table-column>
                      </el-table-column>
                      <el-table-column label="Others" align="center">
                        <el-table-column sortable prop="other_service_th" label="คำอธิบาย (ภาษาไทย)" width="210"></el-table-column>
                        <el-table-column sortable prop="other_service_en" label="คำอธิบาย (ภาษาอังกฤษ)" width="220"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="อัตราค่าบริการเฉลี่ย  (ทั้ง Postpaid และ Prepaid)" align="center">
                      <el-table-column label="บริการเสียง" align="center">
                        <el-table-column sortable prop="voice_per_minute" label="(บาท/นาที)" width="120"></el-table-column>
                        <el-table-column sortable prop="voice_per_second" label="(บาท/วินาที)" width="130"></el-table-column>
                        <el-table-column sortable prop="voice_remark" label="เงื่อนไขอื่นๆ" width="120"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ SMS" align="center">
                        <el-table-column sortable prop="sms_per_message" label="(บาท/ข้อความ)" width="140"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ MMS" align="center">
                        <el-table-column sortable prop="mms_per_message" label="(บาท/ข้อความ)" width="140"></el-table-column>
                      </el-table-column>
                      <el-table-column label="บริการ Internet" align="center">
                        <el-table-column sortable prop="internet_per_MB" label="(บาท/MB)" width="130"></el-table-column>
                      </el-table-column>
                      <el-table-column label="WiFi" align="center">
                        <el-table-column sortable prop="wifi_average" label="(คำอธิบาย)" width="120"></el-table-column>
                      </el-table-column>
                      <el-table-column sortable label="Others" align="center">
                        <el-table-column sortable prop="other_average" label="(คำอธิบาย)" width="120"></el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column label="อัตราค่าบริการต่อหน่วยในส่วนที่เกินกว่าสิทธิการใช้งานของรายการส่งเสริมการขาย (*เฉพาะ Postpaid)" align="center">
                      <el-table-column label="อัตราค่าบริการเสียง" align="center">
                        <el-table-column label="นาทีใดๆสูงสุด" align="center">
                          <el-table-column sortable prop="average_voice_service" label="(บาท/นาที)" width="120px"></el-table-column>
                        </el-table-column>
                        <el-table-column label="เงื่อนไขอื่นๆ" align="center">
                          <el-table-column sortable prop="average_voice_remark_th" label="คำอธิบาย (ภาษาไทย)" width="190px"></el-table-column>
                          <el-table-column sortable prop="average_voice_remark_en" label="คำอธิบาย (ภาษาอังกฤษ)" width="200px"></el-table-column>
                        </el-table-column>
                      </el-table-column>
                      <el-table-column label="อัตราค่าบริการด้านข้อมูล" align="center">
                        <el-table-column label="บริการ SMS" align="center">
                          <el-table-column sortable prop="average_sms_service" label="(บาท/ข้อความ)" width="150"></el-table-column>
                        </el-table-column>
                        <el-table-column label="บริการ MMS" align="center">
                          <el-table-column sortable prop="average_mms_service" label="(บาท/ข้อความ)" width="150"></el-table-column>
                        </el-table-column>
                        <el-table-column label="บริการ Internet" align="center">
                          <el-table-column sortable prop="average_internet_service" label="(บาท/MB)" width="120px"></el-table-column>
                        </el-table-column>
                        <el-table-column label="เงื่อนไขอื่นๆ" align="center">
                          <el-table-column sortable prop="average_other_service_th" label="คำอธิบาย (ภาษาไทย)" width="190px"></el-table-column>
                          <el-table-column sortable prop="average_other_service_en" label="คำอธิบาย (ภาษาอังกฤษ)" width="200px"></el-table-column>
                        </el-table-column>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column sortable prop="service_charge_type" label="รูปแบบการคิดค่าบริการประเภทเสียง (minute/second)" width="250" align="center"></el-table-column>
                    <el-table-column sortable prop="promotion_condition_th" label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาไทย)" width="310"></el-table-column>
                    <el-table-column sortable prop="promotion_condition_en" label="ข้อกำหนดและเงื่อนไขแพ็กเกจ (ภาษาอังกฤษ)" width="330"></el-table-column>
                    <el-table-column label="สิทธิพิเศษ (ที่ไม่มีค่าใช้บริการ)" align="center">
                      <el-table-column sortable prop="privilege_content_th" label="บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาไทย)" width="370px"></el-table-column>
                      <el-table-column sortable prop="privilege_content_en" label="บริการความบันเทิง (ดูหนัง ทีวี ฟังเพลง ภาษาอังกฤษ)" width="390px"></el-table-column>
                      <el-table-column sortable prop="privilege_social_th" label="บริการโซเชียลมีเดีย (ภาษาไทย)" width="260px"></el-table-column>
                      <el-table-column sortable prop="privilege_social_en" label="บริการโซเชียลมีเดีย (ภาษาอังกฤษ)" width="270px"></el-table-column>
                      <el-table-column sortable prop="privilege_game_th" label="บริการเกม (ภาษาไทย)" width="210px"></el-table-column>
                      <el-table-column sortable prop="privilege_game_en" label="บริการเกม (ภาษาอังกฤษ)" width="220px"></el-table-column>
                      <el-table-column sortable prop="privilege_premium_th" label="พรีเมียม (ภาษาไทย)" width="200px"></el-table-column>
                      <el-table-column sortable prop="privilege_premium_en" label="พรีเมียม (ภาษาอังกฤษ)" width="200px"></el-table-column>
                      <el-table-column sortable prop="privilege_device_th" label="อุปกรณ์อื่นๆ (ภาษาไทย)" width="220px"></el-table-column>
                      <el-table-column sortable prop="privilege_device_en" label="อุปกรณ์อื่นๆ (ภาษาอังกฤษ)" width="220px"></el-table-column>
                      <el-table-column sortable prop="privilege_other_th" label="การให้บริการอื่นๆ (ภาษาไทย)" width="230px"></el-table-column>
                      <el-table-column sortable prop="privilege_other_en" label="การให้บริการอื่นๆ (ภาษาอังกฤษ)" width="250px"></el-table-column>
                    </el-table-column>
                    <el-table-column label="ย่านคลื่นความถี่" align="center">
                      <el-table-column sortable prop="signal_900" label="900 MHz" align="center" width="130">
                        <template slot-scope="scope" v-if="scope.row.signal_900 == 1">✔</template>
                      </el-table-column>
                      <el-table-column sortable prop="signal_1800" label="1800 MHz" align="center" width="130">
                        <template slot-scope="scope" v-if="scope.row.signal_1800 == 1">✔</template>
                      </el-table-column>
                      <el-table-column sortable prop="signal_2100" label="2.1 GHz" align="center" width="130">
                        <template slot-scope="scope" v-if="scope.row.signal_2100 == 1">✔</template>
                      </el-table-column>
                      <el-table-column sortable prop="signal_other" label="ย่านความถี่อื่นๆ" align="center" width="150">
                        <template slot-scope="scope" v-if="scope.row.signal_other == 1">✔</template>

                      </el-table-column>
                    </el-table-column>
                    <el-table-column sortable prop="promotion_link_url" label="ลิงค์เว็บไซต์ หรือลิงค์โปรโมชั่นของผู้ให้บริการ" width="350px">
                      <template slot-scope="scope">
                        {{ safeDecodeURI(scope.row.promotion_link_url) }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="promotion_ussd" label="หมายเลข USSD สำหรับเปลี่ยนรายการส่งเสริมการขาย" width="390px">
                      <template slot-scope="scope">
                        {{ safeDecodeURI(scope.row.promotion_ussd) }}
                      </template>
                    </el-table-column>
                    <el-table-column sortable prop="promotion_banner" label="ลิงก์รูปโฆษณา หรือรูปรายการส่งเสริมการขาย" width="350px">
                      <template slot-scope="scope">
                        {{ safeDecodeURI(scope.row.promotion_banner) }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="จัดการ"
                      width="240"
                      align="center"
                      fixed="right"
                    >
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="light" content="ดูข้อมูล" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="success"
                            @click="handleView(scope.row)"
                          >
                            <i class="el-icon-view"></i>
                          </el-button>
                        </el-tooltip>
                        <template v-if="isProvider && !scope.row.deleted_at && manage_permission.includes('edit')">
                          <template v-if="!scope.row.cr_status || scope.row.cr_status == 'approve_edit'">
                            <el-tooltip class="item" effect="light" content="ส่งคำร้อง" placement="top" :enterable="false">
                              <el-button
                                class="custom-btn"
                                size="mini"
                                type="info"
                                @click="handleRequest(scope.row)"
                              >
                                <i class="el-icon-message"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                          <template v-else-if="['reject_request','reject_edit'].includes(scope.row.cr_status)">
                            <el-tooltip class="item" effect="light" content="สถานะ" placement="top" :enterable="false">
                              <el-button
                                size="mini"
                                type="primary"
                                @click="handleInfo(scope.row)"
                              >
                                <i class="el-icon-info"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                          <template v-else>
                            <el-tooltip class="item" effect="light" content="แก้ไข" placement="top" :enterable="false">
                              <el-button
                                :disabled="scope.row.cr_status !== 'approve_request'"
                                size="mini"
                                type="primary"
                                @click="handleEdit(scope.row)"
                              >
                                <i class="el-icon-edit"></i>
                              </el-button>
                            </el-tooltip>
                          </template>
                        </template>
                        <el-tooltip v-if="!scope.row.deleted_at" class="item" effect="light" content="ประวัติ" placement="top" :enterable="false">
                          <el-button
                            class="custom-btn"
                            size="mini"
                            type="warning"
                            @click="viewhistory(scope.row)"
                          >
                            <i class="el-icon-time"></i>
                          </el-button>
                        </el-tooltip>
                        <template v-if="!scope.row.cr_status || ['approve_edit','reject_request'].includes(scope.row.cr_status)">
                          <el-tooltip class="item" effect="light" content="ลบ" placement="top" v-if="isProvider && !scope.row.deleted_at && manage_permission.includes('delete')">
                            <el-button
                              class="custom-btn"
                              size="mini"
                              type="danger"
                              @click="handleDelete(scope.row)"
                              >
                              <i class="el-icon-delete-solid"></i>
                            </el-button>
                          </el-tooltip>
                        </template>
                        <template v-else-if="isProvider && !(scope.row.active_status == 0 && scope.row.cr_status == 'approve_request')">
                          <el-tooltip class="item" effect="light" content="ยกเลิกคำร้อง" placement="top" :enterable="false">
                            <el-button
                              class="custom-btn"
                              size="mini"
                              type="danger"
                              @click="handleCancelRequest(scope.row)"
                              >
                              <i class="el-icon-close"></i>
                            </el-button>
                          </el-tooltip>
                        </template>
                        <template v-if="scope.row.active_status == 1" >
                          <el-tooltip class="item" effect="light" content="ระงับชั่วคราว" placement="top" :enterable="false">
                            <el-button
                              v-if="!isProvider"
                              class="custom-btn"
                              size="mini"
                              type="danger"
                              @click="suspendAlert(scope.row)"
                            >
                              <i class="el-icon-warning-outline"></i>
                            </el-button>
                          </el-tooltip>
                        </template>
                        <template v-else-if="!isProvider">
                          <el-tooltip class="item" effect="light" content="ยกเลิกการระงับชั่วคราว" placement="top" :enterable="false">
                            <el-button
                              class="custom-btn"
                              size="mini"
                              type="primary"
                              @click="publishConfirm(scope.row)"
                            >
                              <i class="el-icon-warning-outline"></i>
                            </el-button>
                          </el-tooltip>
                        </template>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <modalView
                    :info="info"
                    :dialog="dialog"
                    @checkModal="closeModal"
                  ></modalView>
                  <modalRequest
                    :info="info"
                    :requestDialog="requestDialog"
                    @checkModal="closeModal"
                    @confirm="sendRequestForm"
                  ></modalRequest>
                  <el-dialog
                    title="ลบข้อมูลโทรศัพท์เคลื่อนที่"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :before-close="handleClose"
                    >
                    <span>กรุณากดยืนยันการลบข้อมูล</span>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogVisible = false"
                        >ยกเลิก</el-button
                      >
                      <el-button type="primary" @click="dialogVisible = false"
                        >ยืนยัน</el-button
                      >
                    </span>
                  </el-dialog>
                  <el-dialog title="ระงับการเผยแพร่ข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogUnpublish">
                    <el-form :model="unpublishForm">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{ unpublishForm.promotion_code }}
                      </el-form-item>
                      <el-form-item label="เหตุผลของการระงับ" >
                        <el-input v-model="unpublishForm.cr_remark" type="textarea" :rows="3" show-word-limit maxlength="250"></el-input>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogUnpublish = false">ยกเลิก</el-button>
                      <el-button type="primary" @click="suspendConfirm()">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="สถานะคำร้องขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="dialogReject" >
                    <el-form :model="info" :label-position="'top'">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{info.promotion_code}}
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                        {{info.promotion_name_th}}
                      </el-form-item>
                      <el-form-item label="สถานะคำร้อง">
                        {{cr_status_th[info.cr_status]}}
                      </el-form-item>
                      <el-form-item label="คำอธิบาย" >
                        {{info.cr_remark}}
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogReject = false">ปิดหน้าต่าง</el-button>
                      <el-button v-if="info.cr_status == 'reject_request'" type="primary" @click="toRequest()">ส่งคำร้องขอแก้ไขอีกครั้ง</el-button>
                      <el-button v-else type="primary" @click="toEdit()">ไปยังหน้าแก้ไขข้อมูล</el-button>
                    </span>
                  </el-dialog>
                  <el-dialog title="ยกเลิกการขอแก้ไขข้อมูลรายการส่งเสริมการขาย" :visible.sync="cancelRequestDialog" >
                    <el-form :model="info" :label-position="'top'">
                      <el-form-item label="รหัสรายการส่งเสริมการขาย">
                        {{info.promotion_code}}
                      </el-form-item>
                      <el-form-item label="ชื่อรายการส่งเสริมการขาย">
                        {{info.promotion_name_th}}
                      </el-form-item>
                      <el-form-item label="เหตุผลการขอยกเลิกแก้ไข" >
                        <el-input type="textarea" maxlength="250" show-word-limit :rows="5" v-model="info.cr_remark" autocomplete="off"></el-input>
                      </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="cancelRequestDialog = false">ปิดหน้าต่าง</el-button>
                      <el-button type="primary" @click="cancelMobileRequest(info);cancelRequestDialog = false">ยืนยัน</el-button>
                    </span>
                  </el-dialog>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex"
import modalView from "../Modal/Modal_mobile_promotion"
import modalRequest from "../Modal/Modal_request_operator"
export default {
  components: {
    modalView: modalView,
    modalRequest: modalRequest
  },
  created() {
    const cookie = this.$cookies.get('user_nbtc')
    this.isProvider = !!cookie.provider_id
    this.manage_permission = JSON.parse(atob(this.$cookies.get("user_nbtc").permission)).Manage_mobile
  },
  mounted() {
    const userinfo = this.$cookies.get("user_nbtc")
    this.usertype = userinfo.provider_id ? 'operator' : 'admin'
    this.getProviderList('mobile')
    this.form.provider_id = userinfo.provider_id
  },
  data() {
    return {
      isProvider : false,
      manage_permission : [],
      usertype : null,
      dialog: false,
      checkPermission: false,
      dialogVisible: false,
      dialogReject: false,
      label_position: "top",
      form: {
        page: 1,
        page_size: 10,
        namePromotion: "",
        provider_id: null,
        promotion_type: "",
        promotion_category: "",
        month: "",
        service_status: ['S','CS','U','CU'],
        priceRange: [0, 1600],
        promotion_status: 'active',
        promotion_source: 'import'
      },
      dialogFormVisible: false,
      current_page: 1,
      tableProps: {
        border: false,
        stripe: true
      },
      info: {
        promotion_code: "",
        cr_remark: ""
      },
      requestDialog : false,
      dialogUnpublish : false,
      unpublishForm : {},
      cancelRequestDialog: false,
      addPromotionDialog : false,
      monthly_regulate : null,
      upload_type : null
    };
  },
  computed: {
    ...mapState({
      provider: store => store.Promotion.provider,
      data_table: store => store.Promotion.data_table,
      loading: store => store.Promotion.loading,
      total: store => store.Promotion.total,
      regulate_list : store => store.Promotion.regulate_list,
      cr_status_th : store => store.Manage_request.cr_status_th
    })
  },
  methods: {
    ...mapActions({
      setProvider: "Promotion/setProvider",
      searchPromotion: "Promotion/searchPromotion",
      removePromotion: "Promotion/removePromotion",
      editPromotion: "Promotion/editPromotion",
      findHistory: "Promotion/findHistory",
      sendRequestForm: "Promotion/sendRequest",
      sendSuspendForm: "Manage_request/suspendPromotion",
      getProviderList : "Promotion/getProviderList",
      cancelMobileRequest : "Manage_request/cancelMobileRequest"
    }),
    safeDecodeURI(str) {
      if (!str) return '';
      try {
        return decodeURI(str);
      } catch (e) {
        console.warn('Cannot decode URI:', str);
        return str;
      }
    },
    loadData(queryInfo, form) {
      this.form = Object.assign(this.form, queryInfo)
      this.searchPromotion(this.form);
    },
    handleClose() {},
    viewhistory(row) {
      this.findHistory({ promotion_id: row.promotion_id });
    },
    changeTooltip(value) {
      if (value == 1600) {
        return "1500 ขึ้นไป";
      }
      return value;
    },
    handleView(row) {
      this.dialog = true;
      this.info = row;
    },
    closeModal(value) {
      this.dialog = value;
      this.requestDialog = value
    },
    handleRequest(row) {
      this.requestDialog = true;
      this.info = row;
    },
    handleEdit(row){
      this.$store.commit('Promotion/SET_EDIT_ROW',row)
      this.$router.push({name : 'Edit_promotion_mobile'})
    },
    handleDelete(row) {
      this.$confirm("ลบข้อมูล", "แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      })
        .then(() => {
          this.removePromotion(row.promotion_id);
        })
        .catch(() => {});
    },
    suspendAlert(row){
      if(['approve_request','waiting','reject_edit'].includes(row.cr_status)){
        return this.$confirm("ไม่สามารถระงับรายการส่งเสริมการขายได้เนื่องจากอยู่ระหว่างการดำเนินการแก้ไขข้อมูล","แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }
      this.$confirm("ระงับรายการส่งเสริมการขายชั่วคราว","แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "warning"
      }).then(()=>{
        this.unpublishForm = {
          type : 'mobile',
          cr_remark : '',
          cr_status : 'approve_request',
          promotion_code : row.promotion_code,
          promotion_id : row.promotion_id,
          promotion_name : row.promotion_name_th,
          revision_id : row.revision_id,
          provider_id : row.provider_id,
          active_status : 0
        }
        this.dialogUnpublish = true
      })
    },
    suspendConfirm(){
      this.sendSuspendForm(this.unpublishForm)
      this.dialogUnpublish = false
      this.current_page = 1
      this.$store.commit('Promotion/SET_ACTIVE_BUTTON',this.unpublishForm.promotion_id)
    },
    publishConfirm(row){
      this.$confirm("ยกเลิกการระงับรายการส่งเสริมการขาย","แจ้งเตือน", {
        confirmButtonText: "ตกลง",
        cancelButtonText: "ยกเลิก",
        showCancelButton: true,
        type: "primary"
      }).then(()=>{
        this.sendSuspendForm({
          type : 'mobile',
          cr_remark : '',
          cr_status : 'approve_edit',
          promotion_code : row.promotion_code,
          promotion_id : row.promotion_id,
          promotion_name : row.promotion_name_th,
          revision_id : row.revision_id,
          provider_id : row.provider_id,
          active_status : 1
        })
        this.current_page = 1
        this.$store.commit('Promotion/SET_ACTIVE_BUTTON',row.promotion_id)
      })
    },
    handleInfo(row){
      this.info = row
      this.dialogReject = true
    },
    toRequest(row){
      this.dialogReject = false
      this.handleRequest(this.info)
    },
    toEdit(){
      this.handleEdit(this.info)
    },
    handleCancelRequest(row){
      this.cancelRequestDialog = true
      this.info.promotion_code = row.promotion_code
      this.info.promotion_name_th = row.promotion_name_th
      this.info.promotion_id = row.promotion_id
      this.info.revision_id = row.revision_id
    },
    add_promotion_dialog(type){
      this.monthly_regulate = null
      this.upload_type = type
      this.addPromotionDialog = true
      this.$store.dispatch('Promotion/getRegulateList')
    },
    addPromotion(){
      if(this.monthly_regulate){
        this.$store.commit('Promotion/CHANGE_dateMonthly',this.monthly_regulate)
        this.addPromotionDialog = false
        var path = this.upload_type == 'PDF' ? "Add_file_promotion" : "Add_promotion_mobile"
        this.$router.push({ name:  path})
      }else{
        this.$confirm("กรุณาเลือกรอบการนำส่งข้อมูล","แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: false,
          type: "warning"
        })
      }
    }
  }
};
</script>
